import React, { useEffect, useState } from "react";
import { Alert, Typography } from "@mui/material";
import DistributionReviewApi from "../../../../../infrastructure/api/distributionReview";

/**
 * وضعیت مسیر شرکت توزیع برای درخواست:
 * فقط برای شرکت‌هایی که طبق توافق چرخه کارتابل‌شان فعال است، پس از تأیید ناظر سولارنت
 * پرونده خودکار به کارتابل امور ارجاع می‌شود؛ در غیر این صورت روال قبلی ادامه دارد.
 */
const DistributionReferralChoicePanel = ({ requestId }) => {
  const [routing, setRouting] = useState(null);

  useEffect(() => {
    if (!requestId) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const res = await DistributionReviewApi.getRoutingStatus(requestId);
        if (!cancelled) setRouting(res?.data ?? res?.Data ?? null);
      } catch {
        if (!cancelled) setRouting(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [requestId]);

  if (!requestId || !routing) return null;

  const enabled = Boolean(
    routing.portalReviewEnabled ?? routing.PortalReviewEnabled
  );
  if (!enabled) return null;

  const companyName =
    routing.distributionCompanyName ?? routing.DistributionCompanyName;
  const areaName = routing.distributionAreaName ?? routing.DistributionAreaName;
  const review = routing.review ?? routing.Review;
  const stageTitle = review?.stageTitle ?? review?.StageTitle;
  const suggested = Boolean(
    routing.companySuggestedFromCoverage ?? routing.CompanySuggestedFromCoverage
  );
  const candidateCount = (
    routing.candidateAreas ??
    routing.CandidateAreas ??
    []
  ).length;

  return (
    <Alert severity={areaName ? "info" : "warning"} sx={{ mb: 2 }}>
      <Typography variant="body2">
        شرکت توزیع «{companyName}»
        {suggested ? " (پیشنهاد از روی پوشش شهری امورها)" : ""} در چرخه
        کارتابل سولارنت فعال است؛ پس از تأیید ناظر سولارنت، پرونده به کارتابل
        {areaName ? ` امور «${areaName}» ` : " امور برق "}
        ارجاع می‌شود و ادامه فرایند (وام/مهرسان) تا تأیید شرکت توزیع قفل
        می‌ماند.
      </Typography>
      {!areaName ? (
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          {candidateCount > 1
            ? `شهر این درخواست زیر پوشش ${candidateCount} امور است؛ امور برق هنگام ارجاع توسط ناظر انتخاب می‌شود.`
            : "پوشش شهر این درخواست در امورهای شرکت ثبت نشده است؛ امور برق هنگام ارجاع توسط ناظر انتخاب می‌شود. برای ارجاع خودکار، شهرهای تحت پوشش را در تعریف امور ثبت کنید."}
        </Typography>
      ) : null}
      {stageTitle ? (
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          وضعیت فعلی: {stageTitle}
        </Typography>
      ) : null}
    </Alert>
  );
};

export default DistributionReferralChoicePanel;
